import { z } from 'zod'
import { fallback } from '../../../utilities'

const positionOptions = ['top-left', 'top-right', 'bottom-left', 'bottom-right', 'hide'] as const

const fallbackData = {
	logo: 'bottom-left',
	location: 'bottom-left',
	attribution: 'bottom-right',
	stackOrientation: 'vertical',
} as const

export const storyAdPositioningSchema = z.object({
	logo: z.enum(positionOptions).or(fallback(fallbackData.logo)),
	location: z.enum(positionOptions).or(fallback(fallbackData.location)),
	attribution: z.enum(positionOptions).or(fallback(fallbackData.attribution)),
	stackOrientation: z.enum(['vertical', 'horizontal']).or(fallback(fallbackData.stackOrientation)),
}).or(fallback(fallbackData))

export type StoryAdPositioningConfiguration = z.infer<typeof storyAdPositioningSchema>

export const storyAdPositioningDefault: StoryAdPositioningConfiguration = storyAdPositioningSchema.parse({})
